<template>
  <main class="organization-profile">
    <div v-if="$store.getters.getCompany.dropshipping && $route.name == 'drprord'" style="margin-bottom: 30px;">
        <organization_header :dropshipping="true"/>
    </div>

    <div class="worker-header">
      <div class="tabs">
        <!--<router-link :to="{name}" v-for="({name, title}, key) in navs" :key="key+'nav_org'" class="tabs-item" tag="div" active-class="active">
           {{ title }}
         </router-link>-->
        <!--<div class="tabs-item" v-for="({name, title}, key) in navs" :key="key+'nav_org'" :class="{active: key == select_key}" @click="changeFilter(key)"> {{ title }}</div>-->
        <app-select :options="navs" style="width: 194px;" v-model="select_nav" @input="changeFilter()" label="title"/>
      </div>
      <div class="worker-search" :class="search_class">
        <input autocomplete="off" name="search" v-model="search" placeholder="Поиск" @keyup="getOrders()">
        <img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">
      </div>
      <button class="worker-add" v-if="purchaser">Новый заказ</button>
    </div>
    <div class="filter-block" v-if="can('all.orders.permission') && $route.name != 'drprord'">
      <div class="input-block">
        <h4>{{'Менеджер по продажам'}}</h4>
        <app-select :options="sales_managers" @input="changeFilterManager('sale')" v-model="sale_manager" label="name" :placeholder="'Менеджер по продажам'"/>
      </div>
      <div class="input-block">
        <h4>{{'Менеджер клиентской поддержки'}}</h4>
        <app-select :options="support_managers" @input="changeFilterManager('support')" v-model="support_manager" label="name" :placeholder="'Менеджер клиентской поддержки'"/>
      </div>
    </div>
    <div class="filter-block" v-if="$route.name == 'drprord'" style="top: 47px;">
      <div class="input-block" style="width: 200px;">
        <h4>Дата поступления с:</h4>
        <date-picker v-model="date_from"></date-picker>
        <span class="sum-period" v-if="sum"><span class="fw-500">Сумма заказов:</span> {{sum | currency}}</span>
      </div>
      <div class="input-block" style="width: 200px;">
        <h4>Дата поступления по:</h4>
        <date-picker v-model="date_to"></date-picker>
        <span class="sum-period" v-if="commission_sum"><span class="fw-500">Сумма комиссии:</span> {{commission_sum | currency}}</span>
      </div>
    </div>
    <div class="filter-block" v-if="$route.name == 'drprord'" style="left: 756px; top: 47px;">
      <div class="input-block">
        <h4>Закупщик</h4>
        <app-select :options="purchasers" @input="getOrders()" v-model="selected_purchaser" label="name" :placeholder="'Закупщик'"/>
      </div>
    </div>

    <app-checkbox v-model="notShowComplited" class="check" @input="getOrders">Не показывать завершенные</app-checkbox>
    <loading-container :loading="loading" height="400">
      <div class="scroll-table" style="overflow-x: auto; padding-top: 100px; margin-top: -100px;">
      <table>
        <tr>
          <th width="100px">
            <div class="order-buttons-container">
              ID Заказа
              <div class="order-buttons">
                <svg width="10" height="6" class="order-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('id_asc')" :class="{active: order == 'id_asc'}">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('id_desc')" :class="{active: order == 'id_desc'}" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
              </div>
            </div>
          </th>
          <th>
            <div class="order-buttons-container">
              Дата поступления
              <div class="order-buttons">
                <svg width="10" height="6" class="order-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('send_date_asc')" :class="{active: order == 'send_date_asc'}">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('send_date_desc')" :class="{active: order == 'send_date_desc'}" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
              </div>
            </div>
          </th>
          <th>
            <div class="order-buttons-container">
              Дата создания
              <div class="order-buttons">
                <svg width="10" height="6" class="order-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('created_asc')" :class="{active: order == 'created_asc'}">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('created_desc')" :class="{active: order == 'created_desc'}" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
              </div>
            </div>
          </th>
          <th>
            <div class="order-buttons-container">
              Клиент
              <div class="order-buttons">
                <svg width="10" height="6" class="order-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('purchaser_asc')" :class="{active: order == 'purchaser_asc'}">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('purchaser_desc')" :class="{active: order == 'purchaser_desc'}" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
              </div>
            </div>
          </th>
          <th>
            <div class="order-buttons-container">
              Сумма, руб.
              <div class="order-buttons">
                <svg width="10" height="6" class="order-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('sum_asc')" :class="{active: order == 'sum_asc'}">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('sum_desc')" :class="{active: order == 'sum_desc'}" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
              </div>
            </div>
          </th>
          <th v-if="$route.name == 'drprord'">
            Комиссия, руб.
          </th>
          <th>
            <div class="order-buttons-container">
              Объем
              <div class="order-buttons">
                <svg width="10" height="6" class="order-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('vol_asc')" :class="{active: order == 'vol_asc'}">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('vol_desc')" :class="{active: order == 'vol_desc'}" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
              </div>
            </div>
          </th>
          <th>
            <div class="order-buttons-container">
              Вес
              <div class="order-buttons">
                <svg width="10" height="6" class="order-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('weight_asc')" :class="{active: order == 'weight_asc'}">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('weight_desc')" :class="{active: order == 'weight_desc'}" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
              </div>
            </div>
          </th>
          <th>
            <div class="order-buttons-container">
              ТК
              <div class="order-buttons">
                <svg width="10" height="6" class="order-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('delivery_company_asc')" :class="{active: order == 'delivery_company_asc'}">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('delivery_company_desc')" :class="{active: order == 'delivery_company_desc'}" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
              </div>
            </div>
          </th>
          <th>
            <div class="order-buttons-container">
              Статус
              <div class="order-buttons">
                <svg width="10" height="6" class="order-button cp" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" @click="changeOrder('status_asc')" :class="{active: order == 'status_asc'}">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
                <svg width="10" class="cp" style="transform: rotate(180deg)" height="6" viewBox="0 0 10 6" fill="none" @click="changeOrder('status_desc')" :class="{active: order == 'status_desc'}" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.70711 0.707106L9.29289 4.29289C9.92286 4.92286 9.47669 6 8.58579 6L1.41421 6C0.523309 6 0.0771428 4.92286 0.707108 4.29289L4.29289 0.707106C4.68342 0.316582 5.31658 0.316582 5.70711 0.707106Z" fill="#B6BCC8"/>
                </svg>
              </div>
            </div>
          </th>
          <th width="50px">Вход</th>
          <th width="30px">Меню</th>
          <th width="30px">Отзыв</th>
        </tr>
        <tr v-for="(order, idx) in orders" :key="idx" class="tc">
          <td>{{order.id}}</td>
          <td>{{order.date}}</td>
          <td>{{$moment(order.created_at).format('DD.MM.YYYY')}}</td>
          <td>{{order.purchaser.name}}</td>
          <td style="color: #2CB181" class="text-right">{{order.sum | currency}}</td>
          <td v-if="$route.name == 'drprord'">{{order.commission_sum | currency}}</td>
          <td>{{order.vol}}</td>
          <td>{{order.weight}}</td>
          <td>{{order.delivery_company}}</td>
          <td :class="{done: order.status == 7, wait: order.status == 1, canceled: order.status == 9, edited: order.status == 2}">
            <span v-if="order.status == 9" class="cp" @click="$refs.infoModal.open(order.cancel_comment)">
              {{order.human_status}}
            </span>
            <span v-if="order.status != 9">
              {{order.human_status}}
            </span>
          </td>
          <td>
            <router-link :to="'order/' + order.id + '/edit'" tag="a" style="display: flex; justify-content: center">
              <svg xmlns="http://www.w3.org/2000/svg" width="18px" viewBox="0 0 24 24">
                <path fill="#2CB181" d="M 12 4 C 4 4 1 12 1 12 C 1 12 4 20 12 20 C 20 20 23 12 23 12 C 23 12 20 4 12 4 z M 12 6 C 17.276 6 19.944594 10.267094 20.808594 11.996094 C 19.943594 13.713094 17.255 18 12 18 C 6.724 18 4.0554062 13.732906 3.1914062 12.003906 C 4.0574062 10.286906 6.745 6 12 6 z M 12 8 C 9.791 8 8 9.791 8 12 C 8 14.209 9.791 16 12 16 C 14.209 16 16 14.209 16 12 C 16 9.791 14.209 8 12 8 z M 12 10 C 13.105 10 14 10.895 14 12 C 14 13.105 13.105 14 12 14 C 10.895 14 10 13.105 10 12 C 10 10.895 10.895 10 12 10 z"></path>
              </svg>
            </router-link>
          </td>
          <td style="position: relative;">
            <div style="display: flex">
              <img v-if="order.status > 0" height="18px" @click="openMenu(order.id)" src="@/assets/icons/dots.svg" alt="">
            </div>
            <order-menu
                :ref="`menu${order.id}`"
                @saved="getOrders()"
                :item="order"
                @entityModal="$refs.entityModal.open($event)"
                @setCancelParams="$refs.cancelDiag.open(order)"
                @ordersModal="$refs.ordersModal.open($event)"
            />
          </td>
          <td style="display: flex; justify-content: center">
            <button class="icon" @click="$refs.addRate.open(order.id)" :disabled="order.disabled || order.reviews.length > 0 || order.status != 7">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 172 172" width="24px">
                <g :fill="order.disabled || order.reviews.length > 0 || order.status != 7 ? '#B8AFAF' : '#636974'">
                  <path d="M157.4015,68.20158c-0.63067,-1.92425 -2.28975,-3.3325 -4.29283,-3.64067l-43.83492,-6.74383l-18.46492,-36.92983c-0.91375,-1.82033 -2.7735,-2.97058 -4.80883,-2.97058c-2.03533,0 -3.89508,1.15025 -4.80883,2.97058l-18.46492,36.93342l-43.83492,6.74383c-2.00308,0.30817 -3.65858,1.71642 -4.29283,3.64067c-0.63067,1.92425 -0.12542,4.042 1.30792,5.47175l30.32217,30.32575l-6.751,43.88867c-0.30817,2.00667 0.53392,4.00975 2.18225,5.18867c1.64833,1.17533 3.81983,1.32583 5.61508,0.39417l38.72508,-20.20642l38.7215,20.20642c0.78117,0.40492 1.63758,0.60917 2.48683,0.60917c1.10367,0 2.20017,-0.34042 3.12825,-1.00333c1.64833,-1.17892 2.49042,-3.18558 2.18225,-5.18867l-6.751,-43.88867l30.32217,-30.32575c1.43333,-1.43333 1.94217,-3.55108 1.3115,-5.47533zM102.125,95.24142h-11.03667v11.03667c0,2.967 -2.40442,5.375 -5.375,5.375c-2.97058,0 -5.375,-2.408 -5.375,-5.375v-11.03667h-11.03308c-2.97058,0 -5.375,-2.408 -5.375,-5.375c0,-2.967 2.40442,-5.375 5.375,-5.375h11.03308v-11.03308c0,-2.967 2.40442,-5.375 5.375,-5.375c2.97058,0 5.375,2.408 5.375,5.375v11.03308h11.03667c2.97058,0 5.375,2.408 5.375,5.375c0,2.967 -2.40442,5.375 -5.375,5.375z"></path>
                </g>
              </svg>
            </button>
          </td>
        </tr>
      </table>
      </div>
    </loading-container>
    <br>
    <pagination
      v-show="last_page > 1"
      v-model="page"
      :page-count="last_page"
      :click-handler="getOrders"
    />
    <add-rate-modal ref="addRate" @saved="lockItemReviewButton"/>
    <provider-entity-modal ref="entityModal" @saved="getOrders()"/>
    <cancel-order-modal :key="2" ref="cancelDiag" @getOrders="getOrders"/>
    <info-modal :key="3" ref="infoModal"/>
    <orders-modal ref="ordersModal" @saved="getOrders()"/>
  </main>
</template>

<script>
import LoadingContainer from "@/components/loading-container";
import OrderMenu from "@/pages/order/order-menu";
import AppCheckbox from "@/components/app-checkbox";
import AddRateModal from "@/components/modals/add-rate-modal";
import Pagination from "@/components/pagination";
import AppSelect from "@/components/app-select";
import ProviderEntityModal from "@/components/modals/provider-entity-modal";
import organization_header from "@/components/OrganizationHeader.vue"
import CancelOrderModal from "@/components/modals/cancel-order-modal";
import InfoModal from "@/components/modals/info-modal";
import OrdersModal from "@/components/modals/orders-modal";

export default {
  name: "purchase",
  data: function () {
    return {
      purchaser: false,
      search: '',
      menus:[],
      loading: true,
      contracts: [],
      type: '',
      no_active: false,
      notShowComplited: false,
      orders:[],
      select_key: 0,
      page: 1,
      last_page: 0,
      search_class: '',
      order: 'send_date_desc',
      status: '',
      select_nav: {
        title: 'Все закупки',
        name: 'opur',
      },
      date_from: '',
      date_to: '',
      navs: [
        {
          title: 'Все закупки',
          name: 'prord',
        },
        {
          title: 'Завершенные закупки',
          name: 'oprof',
        },
        // {
        //   title: 'Сервис',
        //   name: 'oprof',
        // },

      ],
      sale_manager: '',
      support_manager: '',
      sales_managers: [],
      support_managers: [],
      dropshipping: 0,
      commission_sum: '',
      sum: '',
      selected_purchaser: '',
      purchasers: []
    }
  },
  mounted() {
    if (this.$route.name == 'drprord') {
      this.dropshipping = 1;
    } else {
        this.search_class = 'prov-search';
    }
    this.purchaser = localStorage.getItem('type') == 1 ? false : true;
    this.getOrders();
    if (this.dropshipping) {
        this.getPurchasers();
    }
    if (this.can('all.orders.permission')) {
      this.getUsers();
    }
  },
  methods: {
    lockItemReviewButton(id){
      this.orders = this.orders.map((item)=>{
        if(item.id == id){
          item.disabled = true;
        }
        return item
      })
    },
    getOrders(){
      if (localStorage.getItem('token')) {
        this.loading = true;
        this.$http.post('/get-orders', {
          token: localStorage.getItem('token'),
          status: this.status,
          search: this.search,
          notShowComplited: this.notShowComplited,
          order: this.order,
          page: this.page,
          support_manager: this.support_manager ? this.support_manager.id : '',
          sale_manager: this.sale_manager ? this.sale_manager.id : '',
          dropshipping: this.dropshipping,
          date_from: this.date_from,
          date_to: this.date_to,
          purchaser: this.selected_purchaser ? this.selected_purchaser.user_id : ''
        }).then(({data}) => {
          if (data.orders) {
            this.orders = data.orders.data;
            this.last_page = data.orders.last_page;
            this.commission_sum = data.commission_sum;
            this.sum = data.sum;
          }
        })
        .catch((error) => {
            console.log(error)
        })
        .finally(()=> {this.loading = false})
      }
    },
    getPurchasers(){
      if (localStorage.getItem('token')) {
        this.$http.post('/get-all-dropshipping-purchasers', {
          token: localStorage.getItem('token'),
        }).then(({data}) => {
          if (data.purchasers) {
            this.purchasers = data.purchasers;
          }
        })
        .catch((error) => {
          console.log(error)
        })
      }
    },
    changeFilter() {
      /*this.select_key = val;*/
      if (this.select_nav.title == 'Завершенные закупки') {
        this.status = 7;
      } else {
        this.status = '';
      }
      this.loading = true;
      this.getOrders();
    },
    changeOrder(val)
    {
      this.order = val;
      this.getOrders();
    },
    openMenu(order_id) {
      for (const key in this.orders) {
        this.$refs['menu'+this.orders[key].id][0].close();
      }
      if (this.select_order != order_id) {
        this.select_order = order_id;
        this.$refs['menu'+order_id][0].open();
      } else {
        this.select_order = '';
      }

    },
    getUsers() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-users', {
          token: localStorage.getItem('token')
        }).then(({data}) => {
          if (data.users) {
            this.support_managers = [];
            this.sales_managers = [];
            for(const key in data.users) {
              data.users[key].name = data.users[key].surname + ' ' + data.users[key].name;
              if (data.users[key].position == 'Менеджер клиентской поддержки') {
                this.support_managers.push(data.users[key]);
              }
              if (data.users[key].position == 'Менеджер по продажам') {
                this.sales_managers.push(data.users[key]);
              }
            }
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    },
    changeFilterManager(val) {
      if (val == 'sale') {
        this.support_manager = [];
      } else {
        this.sale_manager = [];
      }
      this.page = 1;
      this.getOrders();
    }
  },
  watch: {
    date_from: function () {
        if ((this.date_from && this.date_to) || (!this.date_from && !this.date_to)) {
            this.getOrders();
        }
    },
    date_to: function () {
        if ((this.date_from && this.date_to) || (!this.date_from && !this.date_to)) {
            this.getOrders();
        }
    }
  },
  components: {
    AddRateModal,
    AppCheckbox,
    LoadingContainer,
    OrderMenu,
    Pagination,
    AppSelect,
    ProviderEntityModal,
    organization_header,
    CancelOrderModal,
    InfoModal,
    OrdersModal
  }
}
</script>

<style scoped lang="scss">

@media screen and (max-width: 1365px) {
  .prov-search {
    position: absolute !important;
    right: -10px;
    top: 50px;
  }

  .organization-profile {
    padding-right: 0 !important;
    width: 80% !important;
  }

  table {
    margin-top: 28px;
  }
}

.check {
  width: 230px;
}
.cp {
  cursor: pointer;
}
.fw-500 {
  font-weight: 500;
}
.sum-period {
  font-size: 14px;
  color: #7A818F;
}
.filter-block {
  position: absolute;
  top: -21px;
  left: 230px;
}

.filter-block .input-block {
  float: left;
  width: 246px;
  margin-left: 20px;
}

.filter-block .input-block h4 {
  font-size: 12px;
  color: #7A818F;
}

.cp {
  cursor: pointer;
}

.order-buttons svg path {
  fill: rgba(225,225,225, 0.6);
}

.order-buttons svg:hover path {
  fill: rgb(182, 188, 200);
}

.order-buttons .active path {
  fill: rgb(182, 188, 200);
}

.order-button {
  margin-top: 6px;
}
.order-buttons-container {
  position: relative;
}
.order-buttons {
  width: 10px;
  position: absolute;
  right: -6px;
  top: -10px;
}
table tr:nth-child(even) {
  background: unset;
}
table td{
  &.done{
    color: #2CB181;
  }
  &.wait{
    color: #F39220;
  }
  img{
    margin: 0 15px;
    cursor: pointer;
  }
}
table td {
  border-top: none !important;
}
table tr{
  border-bottom: 1px solid #a3a3a3 ;
}
.tc:hover .dots, .tc:hover {
  opacity: 1;
  background: #F9F9FB;
}
.search-block {
  position: absolute;
  top: 0px;
  right: 32px;
}
.organization-profile {
  position: relative;
}
.dots{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0;
  width: 20px;
  transition: opacity .3s, background-color .7s;

  &.active{
    opacity: 1;
  }
}
main {
  margin-top: 32px;
}
.worker-checkbox {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin: 10px 0 12px 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #7A818F;
}
.worker-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  position: absolute;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  box-shadow: 0px 0px 3px #E5E5EA;
  border-radius: 4px;
}
.worker-checkbox:hover input ~ .checkmark {
  background-color: #ccc;
}
.worker-checkbox input:checked ~ .checkmark {
  background-color: #b4b4b4;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.worker-checkbox input:checked ~ .checkmark:after {
  display: block;
}
.worker-checkbox .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.organization-profile {
  width: 100%;
  padding: 0 30px;

  .active {
    color: #2CB181;
    font-weight: 500;
  }
}

.worker {
  position: relative !important;

  &-header {
    height: 40px;
    margin-bottom: 18px;
    display: flex;
    justify-content: space-between;
    button{
      border: none;
      height: 40px;
      width: 20%;
      background: #2CB181;
      border-radius: 4px;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
    }
    .tabs{
      margin-right: auto;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      justify-content: center;
      width: max-content;
      background-color: white;
      border-radius: 4px;
      border: 1px solid #EEF0F3;

      &-item {
        margin: 0;
        position: relative;
        cursor: pointer;
        padding: 10px 15px;
        margin: 2px 0 2px 0;
        color: #7A818F;
      }
      &-item:first-child{
        margin-left: 2px;
      }
      &-item:last-child{
        margin-right: 2px;
      }
      &-item.active {
        background: #EEF0F3;
        border-radius: 4px;
      }
      &-item:after{
        border-left: 1px solid #EEF0F3;
        content: " ";
        position: absolute;
        top: 35%;
        right: 0;
        height: 30%;
        margin-top: auto;
        margin-bottom: auto;
      }
      &-item:last-child:after{
        border-left: unset;
      }
    }
  }

  &-search {
    position: relative;
    width: 20%;
    display: flex;
    justify-content: flex-end;
    margin: 0 8px;

    > input {
      border: 1px solid #EEF0F3;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 40px;
      padding: 0 40px 0 15px;
      outline: none;
    }

    > img {
      position: absolute;
      right: 15px;
      bottom: 50%;
      transform: translateY(50%);
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
  }
  &-add {
    background: #2CB181;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    height: 40px;
    border: none;
    outline: none;
    border-radius: 4px;
    width: 20%;
    margin: 0 0 0 8px;
  }

}
.canceled {
  color:red;
}
.edited {
  color: #36d436;
}
</style>
